import React, { useMemo } from 'react'
import styled from '@emotion/styled'
import { DealDetail } from 'api'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { DataGrid, GridId, GridAutoSizing } from 'view/components/datagrid'
import { createRelatedDealsGridColumnDefs, relatedDealsGridOptions } from '../DealsGridModel'
import { Locale, Translation } from 'locale'

interface RelatedPanelProps extends ModalConsumerProps {
  dealDetails: DealDetail[]
  onClose: () => unknown
  parentGridId: GridId
}

const TitleWrapper = styled.span`
  color: #464646;
  font-size: 14px;
  margin-left: 35px;
`

const DataGridTitle = () => <TitleWrapper>{Locale.translate(Translation.TC_VIEW_RELATED_TRADES)}</TitleWrapper>

export const RelatedPanelComponent: React.FC<RelatedPanelProps> = ({ dealDetails, onClose, parentGridId }) => {
  const columnDefs = useMemo(() => createRelatedDealsGridColumnDefs(parentGridId), [parentGridId])

  if (dealDetails.length === 0) {
    return null
  }

  return (
    <DataGrid
      gridId={GridId.RelatedDealsGrid}
      gridOptions={relatedDealsGridOptions}
      data-test-id="RelatedPanelGrid"
      gridColumnAutoSizing={GridAutoSizing.ALL}
      columnDefs={columnDefs}
      rowData={dealDetails}
      onClose={onClose}
      GroupByToggles={DataGridTitle}
    />
  )
}

export const RelatedPanel = withModal(RelatedPanelComponent)
